/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Customer_Group_SuccessInputs */

const vi_toast_customer_group_success = /** @type {(inputs: Toast_Customer_Group_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo nhóm khách hàng thành công`)
};

/**

* @param {Toast_Customer_Group_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_customer_group_success = /** @type {((inputs?: Toast_Customer_Group_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Customer_Group_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_customer_group_success(inputs)
});